export default __webpack_public_path__ + "static/media/troublesomeIconEmpty.3931a17f.svg";